import { useEffect } from 'react';
import useManageWhatsappGroupsInfrastructure from '../infrastructure/hook/useManageWhatsappGroupsInfrastructure';
import { AddWhatsappGroupInterface } from '../domain/interfaces/WhatsappGroupInterface';

export const useWhatsappGroups = () => {
  const {
    fetchWhatsappGroupsInfrastructure,
    setCurrentPageInfrastructure,
    addWhatsappGroupInfrastructure,
    setWhatsappGroupFormInfrastructure,
    updateWhatsappGroupInfrastructure,
    manageWhatsappGroupsState
  } = useManageWhatsappGroupsInfrastructure();

  useEffect(() => {
    if (manageWhatsappGroupsState.whatsappGroups.length === 0) {
      fetchWhatsappGroupsInfrastructure();
    }
  }, []);

  const fetchWhatsappGroups = (page: number) => {
    setCurrentPage(page)
    fetchWhatsappGroupsInfrastructure(page)
  }

  const setCurrentPage = (page: number) => {
    setCurrentPageInfrastructure(page)
  }

  const handleNextPage = () => {
    if (manageWhatsappGroupsState.pagination.currentPage < manageWhatsappGroupsState.pagination.totalPages) fetchWhatsappGroups(manageWhatsappGroupsState.pagination.currentPage + 1);
  };

  const handlePrevPage = () => {
    if (manageWhatsappGroupsState.pagination.currentPage > 1) fetchWhatsappGroups(manageWhatsappGroupsState.pagination.currentPage - 1);
  };

  const addWhatsappGroup = () => {
    addWhatsappGroupInfrastructure()
  }

  const setWhatsappGroupForm = (form: AddWhatsappGroupInterface) => {
    setWhatsappGroupFormInfrastructure(form)
  }

  const updateWhatsappGroup = () => {
    updateWhatsappGroupInfrastructure()
  }

  return {
    manageWhatsappGroupsState,
    handleNextPage,
    handlePrevPage,
    addWhatsappGroup,
    setWhatsappGroupForm,
    updateWhatsappGroup
  };
};